import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';
import { IMG, Icons } from '../../constant';
import styles from '../../sass/thankyou.module.scss';
import { trackPurchase } from '../../utils/tracking';

const ThankYou = () => {
  const location = useLocation();
  const purchase = location.state?.purchase;

  // Purchase conversion fires only when arriving from a completed checkout.
  useEffect(() => {
    trackPurchase(purchase);
  }, [purchase]);

  return (
    <>
      <Helmet>
        <title>Thank You - Order Confirmed | Dental Stores</title>
        <meta name="description" content="Thank you for your order! Your order has been successfully placed and is being processed." />
      </Helmet>
      
      <div className={styles.thankYouContainer}>
        <div className={styles.thankYouContent}>
          {/* Success Icon */}
          <div className={styles.successIcon}>
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#10B981" strokeWidth="2"/>
              <path d="M9 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {/* Main Heading */}
          <h1 className={styles.mainHeading}>Thank You!</h1>
          <p className={styles.subHeading}>Your order has been placed successfully</p>

          {/* Order Status */}
          <div className={styles.orderStatus}>
            <div className={styles.statusItem}>
              <div className={styles.statusIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12l2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.statusText}>
                <h3>Order Confirmed</h3>
                <p>Your order has been received and confirmed</p>
              </div>
            </div>
            
            <div className={styles.statusItem}>
              <div className={styles.statusIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 7l-.867 12.142A2 2 0 0117.138 21H6.862a2 2 0 01-1.995-1.858L4 7m16 0H4m16 0L3 7m17 0l-1.5-6M4 7l1.5-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.statusText}>
                <h3>Processing</h3>
                <p>We're preparing your items for shipment</p>
              </div>
            </div>

            <div className={styles.statusItem}>
              <div className={styles.statusIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 7l-.867 12.142A2 2 0 0117.138 21H6.862a2 2 0 01-1.995-1.858L4 7m16 0H4m16 0L3 7m17 0l-1.5-6M4 7l1.5-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.statusText}>
                <h3>Shipped</h3>
                <p>Your order will be shipped soon</p>
              </div>
            </div>
          </div>

          {/* Order Information */}
          <div className={styles.orderInfo}>
            <div className={styles.infoCard}>
              <h3>What's Next?</h3>
              <ul>
                <li>You'll receive an email confirmation shortly</li>
                <li>We'll send you tracking information once your order ships</li>
                <li>Our customer service team is available if you have any questions</li>
              </ul>
            </div>

            <div className={styles.infoCard}>
              <h3>Need Help?</h3>
              <p>Contact our support team:</p>
              <div className={styles.contactInfo}>
                <div className={styles.contactItem}>
                  <img src={Icons.support} alt="Support" width="20" height="20" />
                  <span>+91 70931 34343</span>
                </div>
                <div className={styles.contactItem}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>support@dentalstores.in</span>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className={styles.actionButtons}>
            <Link to="/orders" className={styles.primaryButton}>
              View My Orders
            </Link>
            <Link to="/" className={styles.secondaryButton}>
              Continue Shopping
            </Link>
          </div>

          {/* Additional Information */}
          <div className={styles.additionalInfo}>
            <div className={styles.infoSection}>
              <div className={styles.infoIcon}>
                <img src={Icons.shipping} alt="Shipping" width="24" height="24" />
              </div>
              <div>
                <h4>Free Shipping</h4>
                <p>On orders above ₹2,500</p>
              </div>
            </div>
            
            <div className={styles.infoSection}>
              <div className={styles.infoIcon}>
                <img src={Icons.secure} alt="Secure" width="24" height="24" />
              </div>
              <div>
                <h4>Secure Payment</h4>
                <p>100% secure transactions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYou;